import Vue from "vue";
import { desktop, mobile, tablet } from "./modules/composables/deviceInfo.es.js";
import { deviceInfo, setupGlobalMixins } from "./modules/mixins/globalMixins.es.js";
import { setupTheming, themingVuePlugin, useTheming } from "./modules/theming/theming.es.js";
import { WsAnalyticsDirective, bind } from "./modules/directives/wsAnalytics.es.js";
import { WsAutofocusDirective } from "./modules/directives/wsAutofocus.es.js";
Vue.config.productionTip = false;
Vue.config.devtools = false;
export {
  WsAnalyticsDirective,
  WsAutofocusDirective,
  bind,
  desktop,
  deviceInfo,
  mobile,
  setupGlobalMixins,
  setupTheming,
  tablet,
  themingVuePlugin,
  useTheming
};
//# sourceMappingURL=index.es.js.map
